

















































































































































import {Component, Mixins} from 'vue-property-decorator';
import EditDialog from '@/components/EditDialog.vue';
import EditDialogMixin from '@/mixins/EditDialogMixins';
import SelectionList from '@c/controls/selectionList/SelectionList.vue';
import enumsModule from '@/store/modules/enumsModule';
import {MeasurementType} from './enums';
import {httpClient} from '@/api/baseApi';

@Component({
  components: {EditDialog, SelectionList},
})
export default class MeasurementEditDialog extends Mixins(EditDialogMixin) {
  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';

  get eventTypeNames() {
    if (this.moduleDefaultValues.length === 0 && this.data.moduleType) {
      this.getDefaultValues();
    }
    return this.moduleDefaultValues
      ? this.moduleDefaultValues.map(v => ({description: v.description, type: v.type}))
      : null;
  }

  get aliasTypeNames() {
    const aliasTypes = this.moduleDefaultValues.filter((v: any) => v.type === this.data.eventType);
    return aliasTypes.length > 0
      ? aliasTypes[0].fields.map(v => ({description: v.description, type: v.alias}))
      : [];
  }

  get showSpectrumType() {
    return this.data.type == MeasurementType.Spectrum;
  }

  get spectrumTypes() {
    return enumsModule.spectrumTypes;
  }

  get moduleTypeNames() {
    this.moduleDefaultValues = [];
    return enumsModule.moduleTypes
      .filter(x => !x.url.startsWith('monitor'))
      .map(x => ({
        type: x.value,
        name: x.description.replace('dtcp ', ''),
        url: x.url,
      }));
  }

  get measurementTypes() {
    return enumsModule.measurementTypes;
  }

  onMeasuementTypeChange(value: any) {
    if (value != MeasurementType.Spectrum) this.data.spectrumType = null;
  }

  onAliasTypeChange(value: any) {
    const parameterDefaults = this.moduleDefaultValues
      .filter(v => v.type === this.data.eventType)[0]
      .fields.filter(v => v.alias === value)[0];

    // очистка зависимых данных
    this.data = {
      ...this.data,
      phys: '',
      bottomDangerBoundary: null,
      bottomErrorBoundary: null,
      bottomWarningBoundary: null,
      topDangerBoundary: null,
      topErrorBoundary: null,
      topWarningBoundary: null,
      unit: '',
      xAxisDescription: '',
      yAxisDescription: '',
    };

    // обновление значения полей
    this.data = {...this.data, ...parameterDefaults};
  }

  onEventTypeChange() {
    // очистка зависимых данных
    this.data = {
      ...this.data,
      phys: '',
      bottomDangerBoundary: null,
      bottomErrorBoundary: null,
      bottomWarningBoundary: null,
      topDangerBoundary: null,
      topErrorBoundary: null,
      topWarningBoundary: null,
      unit: '',
      xAxisDescription: '',
      yAxisDescription: '',
    };
    this.data.alias = '';
  }

  async onModuleTypeChange() {
    // очистка зависимых данных
    this.data.eventType = '';
    this.data.alias = '';
    this.data = {
      ...this.data,
      phys: '',
      bottomDangerBoundary: null,
      bottomErrorBoundary: null,
      bottomWarningBoundary: null,
      topDangerBoundary: null,
      topErrorBoundary: null,
      topWarningBoundary: null,
      unit: '',
      xAxisDescription: '',
      yAxisDescription: '',
    };

    // получение дефолтных значений
    this.getDefaultValues();
  }

  async getDefaultValues() {
    const currentModuleType = enumsModule.moduleTypes.filter(v => v.value === this.data.moduleType);
    const moduleParametersResponse: {data: any} = await httpClient.get(
      `${currentModuleType[0].url}/events/event_types`,
    );
    this.moduleDefaultValues = moduleParametersResponse.data;
  }
}
